if (!window.basisSdsRequestInitialized) {
  window.basisSdsRequestInitialized = true;

  function updateSdsRequest(link) {
    const section = link.closest('section');
    const select = section?.querySelector('.basis-material-product__summary select[name="id"], .basis-product__details select[name="id"]');
    const option = select?.selectedOptions[0];
    const variantId = option?.value;
    const variantTitle = option?.dataset.variantTitle || option?.textContent?.trim();
    const dimensions = section?.querySelector('input[name="contact[Dimensions / form]"]')?.value?.trim();
    const productUrl = new URL(link.dataset.productPath, window.location.origin);
    if (variantId && variantTitle && variantTitle !== 'Default Title') productUrl.searchParams.set('variant', variantId);

    const lines = [
      'Request type: SDS Request',
      `Product: ${link.dataset.productTitle}`,
      `Product URL: ${productUrl.toString()}`,
      `Handle: ${link.dataset.productHandle}`,
      variantId && variantTitle && variantTitle !== 'Default Title'
        ? `Selected variant: ${variantTitle} (ID: ${variantId})`
        : 'Selected specification / variant: To be confirmed'
    ];
    if (dimensions) lines.push(`Requested size / dimensions: ${dimensions}`);
    link.href = `mailto:sales@basismaterials.com?subject=${encodeURIComponent('SDS Request')}&body=${encodeURIComponent(lines.join('\n'))}`;
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sds-request]');
    if (link) updateSdsRequest(link);
  });
}
